import {EntityType} from '../../features/Form/consts/EntityTypes';
//Action Icons
import {ReactComponent as iconWizard} from '../../images/Icon-actions-Wizard.svg';
import {ReactComponent as IconTypeD} from '../../images/Icon-actions-type-D.svg';
import {ReactComponent as IconTypeP1svg} from '../../images/Icon-actions-type-P-1.svg';
import {ReactComponent as IconPieLine} from '../../images/Icon-actions-Pie-Line-Graph.svg';
import {ReactComponent as IconTypeP2} from '../../images/Icon-actions-type-P-2.svg';
import {ReactComponent as IconTypeR} from '../../images/Icon-actions-type-R.svg';
import {ReactComponent as IconTypeF} from '../../images/Icon-actions-type-F.svg';

import styles from './styles.module.scss';
import {PriorityIcon} from '@priority-software/priority-style-react';

type ActionItem = {
    img: string;
    className: string;
    hoverClass: string;
    active: string;
    icon?: PriorityIcon | null;
};

export const getEntityIcon = (type: EntityType): ActionItem => {
    const icon = ActionIconData[type];
    return icon || defaultEntIcon;
};

const defaultEntIcon = {
    img: IconTypeP1svg,
    className: styles.greenColor,
    hoverClass: styles.greenHover,
    active: styles.greenActive,
    icon: PriorityIcon.dNew
};

const ActionIconData = {
    [EntityType.FORM]: {
        img: IconTypeF,
        icon: PriorityIcon.bulletsList,
        className: styles.primaryBlueColor,
        hoverClass: styles.primaryBlueHover,
        active: styles.primaryBlueActive
    },
    [EntityType.PROCEDURE]: {
        img: IconTypeP1svg,
        className: styles.greenColor,
        hoverClass: styles.greenHover,
        active: styles.greenActive,
        icon: PriorityIcon.dNew
    },
    [EntityType.BIREPORT]: {
        img: IconTypeP2,
        className: styles.orangeColor,
        hoverClass: styles.orangeHover,
        active: styles.orangeActive,
        icon: PriorityIcon.graph
    },
    [EntityType.DASHBOARD]: {
        img: IconPieLine,
        className: styles.violetColor,
        hoverClass: styles.violetHover,
        active: styles.violetActive,
        icon: PriorityIcon.dashboard
    },
    [EntityType.REPORT]: {
        img: IconTypeR,
        className: styles.redColor,
        hoverClass: styles.redHover,
        active: styles.redActive,
        icon: PriorityIcon.iconTypeR1
    },
    [EntityType.DOCUMENT]: {
        img: IconTypeD,
        className: styles.lightBlueColor,
        hoverClass: styles.lightBlueHover,
        active: styles.lightBlueActive,
        icon: PriorityIcon.newReport
    },
    [EntityType.WIZARD]: {
        img: iconWizard,
        className: styles.aquaColor,
        hoverClass: styles.aquaHover,
        active: styles.aquaActive
    }
};
